import SelectorButton from "../../Buttons/SelectorButton/SelectorButton";

import { getLoanPurposeOptionsByDomainName } from "../../../constants/loanPurpose";
import { DOMAIN_NAME } from "../../../constants";
import * as Errors from "../../../utils/errors";

export default function LoanPurpose({  addSelectorsData }) {
  const LOAN_PURPOSE_OPTIONS = getLoanPurposeOptionsByDomainName(DOMAIN_NAME);

  const handleSubmit = (purposeOfLoan) => {
    addSelectorsData("purposeOfLoan", purposeOfLoan, Errors.PURPOSE_OF_LOAN, {
      slideName: "Marital Status",
      slideIndex: 6,
      slideIcon: "MaritalStatus",
    });
  };

  return (
    <div className="carouselSlideWrapper">
      <div className="typographyContainer">
        <h1>Purpose of Loan</h1>
        <p>Please select purpose of Loan</p>
      </div>

      {LOAN_PURPOSE_OPTIONS.map(({ id, row }) => (
        <div
          key={id}
          className="genderInputContainer dataFieldsContainer selectInputContainer"
        >
          {row.map(({ id, label, icon }) => (
            <div key={id} className="maleGenderBtnBox">
              <SelectorButton
                label={label}
                handler={handleSubmit}
                icon={icon}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
